// @flow
import { toastr } from 'react-redux-toastr';

const printWindow = (
  printDivId: string,
  successCb?: Function,
  failureCb?: Function
) => {
  let content = document.getElementById(printDivId);
  if (content) {
    content = content.innerHTML;
  }
  const pri = window.open('', '_blank');
  if (!pri) {
    // throw failure alert
    const errMsg = 'Pop ups are blocked on this page';
    // eslint-disable-next-line
    console.log(errMsg);
    toastr.error('Error', errMsg);
    if (failureCb && typeof failureCb === 'function') {
      failureCb();
    }
  } else {
    pri.document.open();
    pri.document.write(
      `<html>
                <head>
                    <style> 
                        body { 
                            margin: 0; 
                            padding: 0; 
                            font-size: 16px; 
                            line-height: 1.5; 
                        }
                        .print-view { 
                            margin: auto; 
                            page-break-after: always; 
                        }
                        table{
                            width: 100%;
                            max-width: 1000px; 
                            border-collapse: 
                            collapse; 
                            border-spacing: 0; 
                            table-layout: fixed;
                            margin: auto; 
                            margin-bottom: 20px; 
                            font-size: 12px; 
                            line-height: 1.5;
                        }
                        tbody { 
                                word-break: break-word; 
                            }
                        td { 
                            border: 1px solid #CCCCCC; 
                            height: 30px; padding-left: 10px; 
                        } 
                        #deposit-slip-print-view td{
                            border: 1px solid #000000;
                            height: 0; 
                        }                        
                        #main-table td:empty:not(:first-child){
                            border: 1px solid #000000;
                            height: 0; 
                            background-color: #d8d8d8
                        }
                        #main-table>thead td{
                            text-align: center;
                        }
                        @media print {
                            #main-table td:empty:not(:first-child){
                                border: 1px solid #000000 !important;
                                -webkit-print-color-adjust: exact; 
                                height: 0; 
                                background-color: #d8d8d8
                            }
                        }
                        #slip-details td{
                            height: 30px;
                        }
                        #main-table {
                            margin-bottom: 50px;
                        }
                        .big { 
                            height: 60px; 
                        } 
                        </style>
                        
                </head>
                <body onload="window.print()">
                    ${content}  
                    
                </body></html>`
    );
    pri.document.close();
    // if(key){
    //  pri.focus();
    //  pri.print();
    // }
    if (successCb && typeof successCb === 'function') {
      successCb();
    }
  }
};

export default printWindow;
